import { useState, useEffect, useRef } from "react"
import { Box, Typography, TextField, Button, Stack, Link, Divider, Alert, Grid, IconButton } from '@mui/material'
import email from '../../assets/svg/Emailupdate.svg'
import mobile from '../../assets/svg/Mobileupdate.svg'
import MyLodder from "../../components/ddpiloader"

import { useSelector } from "react-redux"
import { useAppData } from "../../redux/appDataProvider"
import ApiClient from "../../utilities/apiClient"
import AppConfig from "../../AppConfig"
import HighlightOffIcon from '@mui/icons-material/HighlightOff'

const NewContactOtp = ({ newContactValue, fieldType, onClose }) => {
  const { userInfo, setUserInfo } = useAppData()

  const apiToken = useSelector(state => state.auth.apiToken)

  const [otp, setOtp] = useState(["", "", "", ""])
  const [secondsLeft, setSecondsLeft] = useState(30)
  const [resendCount, setResendCount] = useState(0)

  const [showlodder, setShowLodder] = useState(false)
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const inputRefs = useRef([])

  useEffect(() => {
    if (secondsLeft === 0 || resendCount > 2) return

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [secondsLeft, resendCount])

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return

    const newOtp = [...otp]
    newOtp[index] = value
    setOtp(newOtp)

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  const handleResendOtp = () => {

    setError(false)
    setErrorMsg("")

    if (resendCount < 2) {
      setSecondsLeft(30)
    }

    setResendCount(prev => prev + 1)

    const payload = {
      clientId: userInfo.CLIENT_ID,
      newValue: newContactValue
      
    }

    try {

      const apiClient = new ApiClient(apiToken)

      apiClient
        .fetchData(AppConfig.api.Profile.sendContactOtp, "POST", payload)
        .then((response) => {
          if (!response) {
            console.error("Error: Response is missing.")
            setError(true)
            return
          }

          if (response.status === 200 && response.data.success) {
            console.log(response.data?.message)
          } else if ((response.status === 400 || response.status === 404 || response.status === 500) && !response.data.success) {
            setError(response.data.message)
            console.log("Error:", response.data?.message)
          } else {
            setError(true)
            console.warn("Unexpected response status:", response.status)
          }

        })
        .catch((error) => {
          console.error("Error during API request (Promise rejection):", error)
          setError(true)
        })
    } catch (error) {
      console.error("Error during API request (Try block) :", error)
      setError(true)
    }

  }

  const handleEsign = () => {
    setShowLodder(true)
    const payload = {
      data: {
        clientId: userInfo.CLIENT_ID,
        clientDpId: userInfo.DP_ID,
        fullName: userInfo.CLIENT_NAME,
        update: fieldType === 'email' ? 'email' : 'mobile',
        updateType: "Modification",
        oldValue: fieldType === "email" ? userInfo?.CLIENT_ID_MAIL : userInfo?.MOBILE_NO,
        newValue: newContactValue,
        mobileNumber: userInfo.MOBILE_NO,
        email: userInfo.CLIENT_ID_MAIL,
        mobile: userInfo.MOBILE_NO,
        source: "updateprofile"
      }
    }

    try {

      const apiClient = new ApiClient(apiToken)

      apiClient
        .fetchData(AppConfig.api.Profile.esign, "POST", payload)
        .then((response) => {
            console.log("response of esign handler",response)
          if (!response) {
            console.error("Error: Response is missing.")
            return
          }

          if (response?.data?.status === 200 && response?.data?.data?.success) {

            window.open(response.data?.data?.url, '_self')
          } else if ((response?.data?.status === 404 || response?.data?.status  === 500) && ! response?.data?.data?.success) {
            console.log("Error:", response.data?.message)
          } else {
            // setError(true)
            console.warn("Unexpected response status:", response?.data?.status )
          }

        })
        .catch((error) => {
          console.error("Error during API request (Promise rejection):", error)
        })
    } catch (error) {
      console.error("Error during API request (Try block) :", error)
    }

  }

  const handleVerifyOtp = () => {

    const payload = {
      clientId: userInfo.CLIENT_ID,
      otpCode: otp.join("")
    }

    try {

      const apiClient = new ApiClient(apiToken)

      apiClient
        .fetchData(AppConfig.api.Profile.verifyNewOtp, "POST", payload)
        .then((response) => {
          if (!response) {
            console.error("Error: Response is missing.")
            setErrorMsg("Error in verify OTP. Please try later.")
            setError(true)
            return
          }

          if (response.status === 200 && response.data.success) {
            handleEsign()
            console.log(response.data?.message)
          } else if ((response.status === 400 || response.status === 404 || response.status === 500) && !response.data.success) {

            setErrorMsg(response.data.message)
            setError(true)
            console.log("Error:", response.data?.message)
          } else {
            setError(true)
            console.warn("Unexpected response status:", response.status)
          }

        })
        .catch((error) => {
          console.error("Error during API request (Promise rejection):", error)
          setErrorMsg("Error in verify OTP. Please try later.")
          setError(true)
        })
    } catch (error) {
      console.error("Error during API request (Try block) :", error)
      setErrorMsg("Error in verify OTP. Please try later.")
      setError(true)
    }

  }

  const maskMobile = (mobile) => mobile?.slice(0, 2) + "XXXXX" + mobile?.slice(-3)
  const maskEmail = (email) => {
    const [user, domain] = email?.split("@")
    const masked = user?.slice(0, 2) + "X".repeat(user.length - 3) + user?.slice(-1)
    return `${masked}@${domain}`
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>

        <Grid container alignItems="center" justifyContent="space-between">
                          <Grid item>
                           <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}}} fontWeight="bold" mb={1}>
          Verify Request by {fieldType === 'email' ? 'Email' : 'Mobile'}
        </Typography>
                          </Grid>
                          <Grid item>
                            <IconButton onClick={onClose}>
                              <HighlightOffIcon sx={{ color: '#F3D45E' }} />
                            </IconButton>
                          </Grid>
                        </Grid>

        

        <Divider sx={{ my: 2, borderColor: "#999" }} />

        <Typography sx={{ color: "#888", mb: 3, fontSize: {xs: '14px', sm: '16px'} }}>Usually takes few seconds</Typography>

        <Box textAlign="center" mb={3}>
          <img src={fieldType === 'email' ? email : mobile} alt="OTP" width={125} />
          <Typography mt={2} sx={{ fontSize: {xs: '14px', sm: '16px'} }}>
            Verify request over New {fieldType === 'email' ? 'Email ID' : 'Mobile Number'}
          </Typography>
          <Typography color="text.secondary" mt={2} sx={{ fontSize: {xs: '14px', sm: '16px'} }}>
            We have sent a 4 digit OTP on <br />
            <strong>{fieldType === "mobile" ? maskMobile(newContactValue) : maskEmail(newContactValue)}</strong>
          </Typography>
        </Box>

        <Stack direction="row" spacing={1} justifyContent="center" mb={2}>
          {otp.map((digit, index) => (
            <TextField
              key={index}
              value={digit}
              inputRef={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => handleOtpChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{
                maxLength: 1,
                style: { textAlign: "center", fontWeight: 'bold' }
              }}
              size="small"
              sx={{ width: 40 }}
            />
          ))}
        </Stack>

        {(resendCount < 2 && secondsLeft > 0) ? (
          <Typography align="center" variant="body2" mb={4} color="text.secondary">
            You can resend OTP in {secondsLeft}s
          </Typography>
        ) : (
          <Typography align="center" variant="body2" mb={4}>
            OTP not received?{" "}
            <Link href="#" onClick={handleResendOtp}>
              Send Again
            </Link>
          </Typography>
        )}

        {error && <Alert severity="error" >
          {errorMsg || "Error in Resend OTP. Please try later."}
        </Alert>}
      </Box>

      <Box>
        <Button
          onClick={handleVerifyOtp}
          fullWidth
          disabled={otp.join("").length !== 4}
          sx={{ background: otp.join("").length !== 4 && "#999 !important" }}
        >
          Verify Request
        </Button>
      </Box>

      <MyLodder canShow={showlodder} />
    </Box>
  )
}

export default NewContactOtp
